import { useContext } from 'react';
import { Project } from '../api/project';
import { CurrentProjectContext } from '../contexts';

export const useCurrentProject = (): Project => {
  const context = useContext(CurrentProjectContext);

  if (!context) {
    throw new Error(
      'Project is null, make sure your using this hook inside CurrentProjectContext.Provider',
    );
  }

  return context;
};
